import { useMemo } from "react";
import { useSelector } from "react-redux";
import { HotelsShopSelectors } from "@b2bportal/core-hotels";
import { useI18nContext } from "@hopper-b2b/i18n";
import type { HotelShopBookingSectionProps } from "@tenant/hotels";

export const useHotelShopBookingSection = ({
  hotel,
  goToNextStep,
}: HotelShopBookingSectionProps) => {
  const { t } = useI18nContext();

  const { data, isLoading: isRoomsLoading } = useSelector(
    HotelsShopSelectors.getRooms
  );

  const available = useMemo(() => {
    return data.length > 0;
  }, [data]);

  return useMemo(() => {
    return {
      hotel,
      nextStep: isRoomsLoading || !available ? null : goToNextStep,
      text: {
        roomCTA: isRoomsLoading
          ? t("loading")
          : t("core-hotels.shop.price.chooseRoomCTA"),
      },
    };
  }, [hotel, isRoomsLoading, available, goToNextStep, t]);
};
